export const DEFAULT_AMBIENT_MUSIC = {
  enabled: false,
  audioUrl: '',
  /** 0–1 */
  volume: 0.35,
};

export function normalizeAmbientMusic(raw) {
  const v = raw && typeof raw === 'object' ? raw : {};
  const vol = Number(v.volume);
  const audioUrl = String(v.audioUrl || '').trim();
  return {
    enabled: v.enabled === true && Boolean(audioUrl),
    audioUrl,
    volume: Number.isFinite(vol)
      ? Math.min(1, Math.max(0, vol))
      : DEFAULT_AMBIENT_MUSIC.volume,
  };
}

export function hasAmbientMusic(raw) {
  const n = normalizeAmbientMusic(raw);
  return n.enabled && Boolean(n.audioUrl);
}

/** Payload API — conserve l’URL et active si une piste est présente. */
export function ambientMusicForPersist(raw) {
  const v = raw && typeof raw === 'object' ? raw : {};
  const audioUrl = String(v.audioUrl || '').trim();
  const vol = Number(v.volume);
  const volume = Number.isFinite(vol)
    ? Math.min(1, Math.max(0, vol))
    : DEFAULT_AMBIENT_MUSIC.volume;
  if (!audioUrl) {
    return { enabled: false, audioUrl: '', volume };
  }
  if (audioUrl.startsWith('data:')) {
    return { enabled: false, audioUrl: '', volume };
  }
  const enabled = v.enabled === true || v.enabled === undefined;
  return {
    enabled,
    audioUrl,
    volume,
  };
}

export function ambientMusicStorageKey(slug) {
  return `wc-ambient-muted:${String(slug || 'site').trim() || 'site'}`;
}
